import { render } from "./StoreTransferDetails.vue?vue&type=template&id=fab9cbb2"
import script from "./StoreTransferDetails.vue?vue&type=script&lang=js"
export * from "./StoreTransferDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__